import { createFileRoute } from '@tanstack/react-router';

import { QuoteRequestsPage as PartLibraryQuoteRequestsPage } from '@/areas/quote-requests/QuoteRequests/PartLibraryQuoteRequestsPage/QuoteRequestsPage';
import { canViewPartLibrarySourcing } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/quote-requests/')({
    staticData: { access: { permissions: canViewPartLibrarySourcing }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <PartLibraryQuoteRequestsPage />;
}
